import { LogoutScreen } from "@/interactors/LogoutScreen";

export default function Logout() {
  return <LogoutScreen />;
}
